// Fixed, never cycled color order for categorical breakdowns, so a group
// always keeps the same color across renders and across widgets
export const CATEGORICAL_COLORS = [
    'var(--general-purple)',
    'var(--general-green)',
    'var(--general-orange)',
    'var(--general-blue)',
    'var(--general-red)',
    'var(--general-yellow)',
    'var(--general-gray)',
];
